import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }

import Popover from "@stimulus-components/popover";
application.register("popover", Popover);

import Rails from "@rails/ujs";
Rails.start();
